/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { View } from "react-native";
import Icon from "react-icons-kit";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Fade from "@material-ui/core/Fade";
import { arrow_down } from "react-icons-kit/ikons/arrow_down";

import { Text, styles } from "UpduoLibrary";
import { skaleWebTextGray } from "config/UpduoColors";

export default function PermissionsDropDown({
  onChange,
  selectedText,
  optionsArray,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const _handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const _handleClose = () => {
    setAnchorEl(null);
  };

  const _handleChange = (value) => {
    onChange(value);
    _handleClose();
  };

  return (
    <View
      style={{
        ...styles.dropdown,
        borderWidth: 0,
        alignItems: "center",
      }}
    >
      <ButtonBase
        aria-controls={"fade-menu"}
        aria-haspopup={"true"}
        onClick={_handleClick}
        style={{
          color: skaleWebTextGray,
          justifyContent: "left",
        }}
      >
        <Text
          style={{
            color: skaleWebTextGray,
            fontSize: 14,
            textTransform: "capitalize",
          }}
        >
          {selectedText}
        </Text>
        <Icon style={{ marginLeft: 4 }} size={15} icon={arrow_down} />
      </ButtonBase>
      <Menu
        id={"fade-menu"}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={_handleClose}
        TransitionComponent={Fade}
      >
        {optionsArray.map((item) => {
          return (
            <MenuItem
              key={item}
              onClick={() => {
                _handleChange(item);
              }}
              style={{
                color: skaleWebTextGray,
                fontFamily: "ObjectSans-Regular",
                textTransform: "capitalize",
              }}
            >
              {item}
            </MenuItem>
          );
        })}
      </Menu>
    </View>
  );
}
